import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import styled from 'styled-components';
import { CSSProperties, ReactNode, RefObject } from 'react';
import { makeStyles } from '@mui/styles';

import NoData from 'components/NoData';

const useStyles = makeStyles({
  root: {
    width: '100%',
    overflowX: 'auto',
  },
  table: {
    minWidth: 650,
  },
  cell: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  '@media (max-width: 767px)': {
    root: {
      width: '100%',
      overflowX: 'scroll',
    },
  },
});

export const TableContainerStyle = styled.div`
  .MuiTableCell-head {
    opacity: 1;
    color: #acacac;
  }
  .MuiTableRow-root {
    height: 0;
  }
`;

interface IProps {
  cells: string[];
  children: ReactNode;
  hasData: boolean;
  bordered?: boolean;
  headerCellStyle?: CSSProperties;
  tableContainerRef?: RefObject<HTMLDivElement>;
}

export const DynamicTable = ({
  cells,
  children,
  hasData,
  bordered,
  headerCellStyle,
  tableContainerRef,
}: IProps) => {
  const classes = useStyles();

  const tableCellSx = bordered
    ? {
        border: '1px solid rgba(224, 224, 224, 1)',
        whiteSpace: 'nowrap' as const,
        padding: '8px 12px',
      }
    : {
        borderBottom: 'none',
        whiteSpace: 'nowrap' as const,
        padding: '8px 12px',
      };

  const headerSx = headerCellStyle
    ? { ...tableCellSx, ...headerCellStyle }
    : tableCellSx;

  return (
    <>
      {hasData ? (
        <TableContainerStyle>
          <TableContainer
            component={Paper}
            ref={tableContainerRef}
            sx={{
              width: '100%',
              boxShadow: 'none',
            }}
            className={classes.root}
          >
            <Table
              className={classes.table}
              stickyHeader
              aria-label="simple table"
              sx={
                bordered
                  ? {
                      borderCollapse: 'collapse',
                      '& .MuiTableCell-root': {
                        border: '1px solid rgba(224, 224, 224, 1)',
                      },
                    }
                  : undefined
              }
            >
              <TableHead>
                <TableRow>
                  {cells.map((cell, index) => (
                    <TableCell align="center" key={index} sx={headerSx}>
                      {cell}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>{children}</TableBody>
            </Table>
          </TableContainer>
        </TableContainerStyle>
      ) : (
        <NoData />
      )}
    </>
  );
};
